import { ContentStateInterface, ContentStateProperty } from '../../../@types/types'
import {
  AbstractScreenValidationResult,
  ScreenValidationResult,
  ValidationResult,
  ValidationSchema,
} from '../../../@types/validation-types'
import { validate } from '../validationService'
import { AddressFeatureState } from '../../../@types/state-types'

export const runValidation = (
  insertionData: ContentStateInterface,
  addressFeature: AddressFeatureState,
  validationSchemaFactory: ValidationSchema
) => {
  const validationMessages: ValidationResult = validate(insertionData, addressFeature, validationSchemaFactory)

  // For national (German) address when the geolocation api fails we display a Geographical assignment component
  // See ManualGeoCoding and NationalAddress components
  // manualCity and manualQuarter fields should only be validated when the geolocation api fails and the address is national
  // manualRegion should be validated when Geographical assignment component is displayed AND when the address is international
  const validateGeographicalAssignmentFields =
    !addressFeature.hasValidGeoCoordinates && !addressFeature.isInternationalAddress

  validationMessages.address.fields = {
    ...validationMessages.address.fields!,
    manualRegion:
      !addressFeature.hasValidGeoCoordinates || addressFeature.isInternationalAddress
        ? validationMessages.address.fields?.manualRegion
        : [],
    manualCity: validateGeographicalAssignmentFields ? validationMessages.address.fields?.manualCity : [],
    manualQuarter: validateGeographicalAssignmentFields ? validationMessages.address.fields?.manualQuarter : [],
  }

  return validationMessages
}

export const hasErrors = (
  validationMessages: ScreenValidationResult<AbstractScreenValidationResult>,
  fieldsToConsider?: ContentStateProperty[]
) =>
  validationMessages?.fields &&
  Object.entries(validationMessages.fields)
    .filter(([property]) => !fieldsToConsider || fieldsToConsider.includes(property as keyof ContentStateInterface))
    .some(([_property, messages]) => messages && messages.length)
